<ng-container *transloco="let translate">
    <header class="warning-header">
        <span class="warning-icon material-symbols-outlined" aria-hidden="true">warning</span>
        <div class="warning-heading">
            <span class="warning-eyebrow">{{ translate('Tolerance warning') }}</span>
            <h2 mat-dialog-title class="warning-title">{{ translate('Variance exceeds tolerance') }}</h2>
        </div>
        <button
            mat-icon-button
            class="warning-close"
            type="button"
            [mat-dialog-close]="false"
            [attr.aria-label]="translate('Close warning')">
            <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button>
    </header>
    <mat-dialog-content class="warning-content">
        <p class="warning-description">
            {{
                translate(
                    'The selected records exceed the configured tolerance. Review the difference below. You can still proceed if this variance is expected.'
                )
            }}
        </p>
        <div class="source-summary">
            <section class="source-details" *ngFor="let source of data.sources; let i = index">
                <div class="source-heading">
                    <span class="source-label">{{ translate(i === 0 ? 'Source 1' : 'Source 2') }}</span>
                    <span class="source-count">{{ translate('Selected records') }}: {{ source.recordCount | number }}</span>
                </div>
                <h3>{{ source.name }}</h3>
                <span class="source-column">{{ translate('Selected column') }}: {{ source.column }}</span>
                <div class="source-total">
                    <span>{{ translate('Total') }}</span>
                    <strong class="numeric">{{ source.total | number : '1.2-20' }}</strong>
                </div>
            </section>
        </div>
        <div class="variance-summary">
            <div>
                <span class="summary-label">{{ translate('Variance') }}</span>
                <span class="variance-formula">{{ translate('Source 1 - Source 2') }}</span>
            </div>
            <div class="variance-values">
                <strong class="variance-value numeric">{{ data.variance | number : '1.2-20' }}</strong>
                <span>
                    {{ translate('Absolute variance') }}:
                    <b class="numeric">{{ absoluteVariance | number : '1.2-20' }}</b>
                </span>
            </div>
        </div>
        <div class="tolerance-heading">
            <h3>{{ translate('Exceeded tolerances') }}</h3>
            <span class="tolerance-count">{{ data.failingFields.length | number }}</span>
        </div>
        <table class="tolerance-table" [attr.aria-label]="translate('Exceeded tolerances')">
            <thead>
                <tr>
                    <th scope="col">{{ translate('Tolerance field') }}</th>
                    <th scope="col" class="numeric">{{ translate('Configured tolerance') }}</th>
                    <th scope="col" class="numeric">{{ translate('Amount exceeded') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr class="tolerance-details" *ngFor="let field of data.failingFields">
                    <th scope="row">{{ field.name }}</th>
                    <td class="numeric">{{ field.tolerance | number : '1.2-20' }}</td>
                    <td class="numeric exceeded-value">{{ field.exceededBy | number : '1.2-20' }}</td>
                </tr>
            </tbody>
        </table>
        <p class="tolerance-note">
            {{
                translate(
                    'Tolerance checks use absolute values. Amount exceeded is the absolute variance minus the absolute configured tolerance.'
                )
            }}
        </p>
    </mat-dialog-content>
    <mat-dialog-actions class="warning-actions">
        <span class="action-hint">{{ translate('Do you want to proceed with this variance?') }}</span>
        <div class="action-buttons">
            <button mat-stroked-button class="warning-cancel" type="button" [mat-dialog-close]="false">
                {{ translate('Go back') }}
            </button>
            <button mat-flat-button class="warning-proceed" type="button" [mat-dialog-close]="true">
                {{ translate('Proceed anyway') }}
                <span class="material-symbols-outlined" aria-hidden="true">arrow_forward</span>
            </button>
        </div>
    </mat-dialog-actions>
</ng-container>
